import {Component, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';

@Component({
  selector: 'app-file-delete-dialog',
  imports: [MatDialogModule, MatButtonModule],
  template: `<h2 mat-dialog-title>Confirm Deletion</h2>
    <mat-dialog-content>
      <p
        ><b>{{ objectName }}</b></p
      >
    </mat-dialog-content>
    <mat-dialog-actions>
      <button matButton="filled" [mat-dialog-close]="false" class="btn-cancel">Cancel</button>
      <button matButton="filled" [mat-dialog-close]="true" class="btn-danger"
        >Permanently delete this {{ objectKind }}!</button
      >
    </mat-dialog-actions>`,
  styleUrl: './object-delete-dialog.component.scss',
})
export class DeleteDialogComponent {
  objectName: string;
  objectKind: string;

  constructor() {
    const data = inject(MAT_DIALOG_DATA) as {objectName: string; objectKind: string};
    this.objectName = data.objectName;
    this.objectKind = data.objectKind;
  }
}
